import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const InterieurCta = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-white py-24 px-6">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="h-px w-6 bg-brand-coral" />
          <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Commençons ensemble</span>
          <span className="h-px w-6 bg-brand-coral" />
        </div>
        <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite leading-tight mb-6">
          Planifiez votre <em className="text-brand-fuchsia">rendez-vous</em>
        </h2>
        <p className="text-brand-gray mb-10 text-lg leading-relaxed">
          Rencontrons-nous pour discuter de votre projet d'aménagement intérieur et explorer ensemble les possibilités créatives.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:hello@evcodesign-ci.com"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
          >
            <i className="ri-calendar-event-line" />
            Planifier un rendez-vous
          </a>
          <Link
            to="/decoration-evenementielle"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-brand-anthracite/20 text-brand-anthracite font-medium text-sm whitespace-nowrap transition-all duration-300 hover:border-brand-fuchsia hover:text-brand-fuchsia"
          >
            <i className="ri-arrow-right-line" />
            Voir nos formules événements
          </Link>
        </div>
      </div>
    </section>
  );
};

export default InterieurCta;
